import {keyframes} from "styled-components";

export const columnOneAnimation = keyframes`
  0% { transform: scaleX(2); }
  16.67% { transform: scaleX(0.8); }
  33.33% { transform: scaleX(0.5); }
  50% { transform: scaleX(0.4); }
  66.67% { transform: scaleX(0.5); }
  83.33% { transform: scaleX(0.8); }
  100% { transform: scaleX(2); }
`;

export const columnTwoAnimation = keyframes`
  0% { transform: scaleX(1); translate: 100%; }
  16.67% { transform: scaleX(2); translate: -20%}
  33.33% { transform: scaleX(0.7); translate: -50%}
  50% { transform: scaleX(0.6); translate: -60%}
  66.67% { transform: scaleX(0.7); translate: -50%}
  83.33% { transform: scaleX(2); translate: -20%}
  100% { transform: scaleX(1); translate: 100%; }
`;

export const columnThreeAnimation = keyframes`
  0% { transform: scaleX(0.6); translate: 100%; }
  16.67% { transform: scaleX(0.7); translate: 80%; }
  33.33% { transform: scaleX(2); translate: -80%; }
  50% { transform: scaleX(1); translate: -100%; }
  66.67% { transform: scaleX(2); translate: -80%; }
  83.33% { transform: scaleX(0.7); translate: 80%; }
  100% { transform: scaleX(0.6); translate: 100%; }
`;

export const columnFourAnimation = keyframes`
  0% { transform: scaleX(0.4); translate: 60%; }
  16.67% { transform: scaleX(0.5); translate: 50%; }
  33.33% { transform: scaleX(0.8); translate: 20%; }
  50% { transform: scaleX(2); translate: -100%; }
  66.67% { transform: scaleX(0.8); translate: 20%; }
  83.33% { transform: scaleX(0.5); translate: 50%; }
  100% { transform: scaleX(0.4); translate: 60%; }
`;

export const rowOneAnimation = keyframes`
  0% { transform: scaleY(2); }
  16.67% { transform: scaleY(0.8); }
  33.33% { transform: scaleY(0.5); }
  50% { transform: scaleY(0.4); }
  66.67% { transform: scaleY(0.5); }
  83.33% { transform: scaleY(0.8); }
  100% { transform: scaleY(2); }
`;

export const rowTwoAnimation = keyframes`
  0% { transform: scaleY(1); translate: 0 100%; }
  16.67% { transform: scaleY(2); translate: 0 -20%}
  33.33% { transform: scaleY(0.7); translate: 0 -50%}
  50% { transform: scaleY(0.6); translate: 0 -60%}
  66.67% { transform: scaleY(0.7); translate: 0 -50%}
  83.33% { transform: scaleY(2); translate: 0 -20%}
  100% { transform: scaleY(1); translate: 0 100%; }
`;

export const rowThreeAnimation = keyframes`
  0% { transform: scaleY(0.6); translate: 0 100%; }
  16.67% { transform: scaleY(0.7); translate: 0 80%; }
  33.33% { transform: scaleY(2); translate: 0 -80%; }
  50% { transform: scaleY(1); translate: 0 -100%; }
  66.67% { transform: scaleY(2); translate: 0 -80%; }
  83.33% { transform: scaleY(0.7); translate: 0 80%; }
  100% { transform: scaleY(0.6); translate: 0 100%; }
`;

export const rowFourAnimation = keyframes`
  0% { transform: scaleY(0.4); translate: 0 60%; }
  16.67% { transform: scaleY(0.5); translate: 0 50%; }
  33.33% { transform: scaleY(0.8); translate: 0 20%; }
  50% { transform: scaleY(2); translate: 0 -100%; }
  66.67% { transform: scaleY(0.8); translate: 0 20%; }
  83.33% { transform: scaleY(0.5); translate: 0 50%; }
  100% { transform: scaleY(0.4); translate: 0 60%; }
`;

export const boxOneAnimation = keyframes`
  0% { transform: scale(2, 2); }
  16.67% { transform: scale(calc(2/3), calc(2/3)); }
  33.33% { transform: scale(calc(2/3), calc(2/3)); }
  50% { transform: scale(calc(2/3), calc(2/3)); }
  66.67% { transform: scale(calc(2/3), calc(2/3)); }
  83.33% { transform: scale(calc(2/3), calc(2/3)); }
  100% { transform: scale(2, 2); }
`;

export const boxTwoAnimation = keyframes`
  0% { transform: scale(calc(2/3), 2); translate: 100%; }
  16.67% { transform: scale(2, calc(2/3)); translate: -33.33%}
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33%}
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33%}
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33%}
  83.33% { transform: scale(2, calc(2/3)); translate: -33.33%}
  100% { transform: scale(calc(2/3), 2); translate: 100%; }
`;

export const boxThreeAnimation = keyframes`
  0% { transform: scale(calc(2/3), 2); translate: 66.67% }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67%}
  33.33% { transform: scale(2, calc(2/3)); translate: -66.67%}
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -66.67%}
  66.67% { transform: scale(2, calc(2/3)); translate: -66.67%}
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67%}
  100% { transform: scale(calc(2/3), 2); translate: 66.67% }
`;

export const boxFourAnimation = keyframes`
  0% { transform: scale(calc(2/3), 2); translate: 33.33%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33%; }
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33%; }
  50% { transform: scale(2, calc(2/3)); translate: -100%; }
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33%; }
  100% { transform: scale(calc(2/3), 2); translate: 33.33%; }
`;

export const boxFiveAnimation = keyframes`
  0% { transform: scale(2, calc(2/3)); translate: 0 100%; }
  16.67% { transform: scale(calc(2/3), 2); translate: 0 -33.33%}
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: 0 -33.33%}
  50% { transform: scale(calc(2/3), calc(2/3)); translate: 0 -33.33%}
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: 0 -33.33%}
  83.33% { transform: scale(calc(2/3), 2); translate: 0 -33.33%}
  100% { transform: scale(2, calc(2/3)); translate: 0 100%; }
`;

export const boxSixAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 100%; }
  16.67% { transform: scale(2, 2); translate: -33.33% -33.33%}
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% -33.33%}
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% -33.33%}
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% -33.33%}
  83.33% { transform: scale(2, 2); translate: -33.33% -33.33%}
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 100%; }
`;

export const boxSevenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 100%; }
  16.67% { transform: scale(calc(2/3), 2); translate: 66.67% -33.33%}
  33.33% { transform: scale(2, calc(2/3)); translate: -66.67% -33.33%}
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -66.67% -33.33%}
  66.67% { transform: scale(2, calc(2/3)); translate: -66.67% -33.33%}
  83.33% { transform: scale(calc(2/3), 2); translate: 66.67% -33.33%}
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 100%; }
`;

export const boxEightAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 100%; }
  16.67% { transform: scale(calc(2/3), 2); translate: 33.33% -33.33%}
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% -33.33%}
  50% { transform: scale(2, calc(2/3)); translate: -100% -33.33%}
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% -33.33%}
  83.33% { transform: scale(calc(2/3), 2); translate: 33.33% -33.33%}
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 100%; }
`;

export const boxNineAnimation = keyframes`
  0% { transform: scale(2, calc(2/3)); translate: 0 66.67%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 0 66.67%; }
  33.33% { transform: scale(calc(2/3), 2); translate: 0 -66.67%; }
  50% { transform: scale(calc(2/3), calc(2/3)); translate: 0 -66.67%; }
  66.67% { transform: scale(calc(2/3), 2); translate: 0 -66.67%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 0 66.67%; }
  100% { transform: scale(2, calc(2/3)); translate: 0 66.67%; }
`;

export const boxTenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 66.67%; }
  16.67% { transform: scale(2, calc(2/3)); translate: -33.33% 66.67%; }
  33.33% { transform: scale(calc(2/3), 2); translate: -33.33% -66.67%; }
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% -66.67%; }
  66.67% { transform: scale(calc(2/3), 2); translate: -33.33% -66.67%; }
  83.33% { transform: scale(2, calc(2/3)); translate: -33.33% 66.67%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 66.67%; }
`;

export const boxElevenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 66.67%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 66.67%; }
  33.33% { transform: scale(2, 2); translate: -66.67% -66.67%; }
  50% { transform: scale(calc(2/3), calc(2/3)); translate: -66.67% -66.67%; }
  66.67% { transform: scale(2, 2); translate: -66.67% -66.67%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 66.67%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 66.67%; }
`;

export const boxTwelveAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 66.67%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 66.67%; }
  33.33% { transform: scale(calc(2/3), 2); translate: 33.33% -66.67%; }
  50% { transform: scale(2, calc(2/3)); translate: -100% -66.67%; }
  66.67% { transform: scale(calc(2/3), 2); translate: 33.33% -66.67%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 66.67%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 66.67%; }
`;

export const boxThirteenAnimation = keyframes`
  0% { transform: scale(2, calc(2/3)); translate: 0 33.33%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 0 33.33%; }
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: 0 33.33%; }
  50% { transform: scale(calc(2/3), 2); translate: 0 -100%; }
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: 0 33.33%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 0 33.33%; }
  100% { transform: scale(2, calc(2/3)); translate: 0 33.33%; }
`;

export const boxFourteenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 33.33%; }
  16.67% { transform: scale(2, calc(2/3)); translate: -33.33% 33.33%; }
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% 33.33%; }
  50% { transform: scale(calc(2/3), 2); translate: -33.33% -100%; }
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: -33.33% 33.33%; }
  83.33% { transform: scale(2, calc(2/3)); translate: -33.33% 33.33%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 100% 33.33%; }
`;

export const boxFifteenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 33.33%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 33.33%; }
  33.33% { transform: scale(2, calc(2/3)); translate: -66.67% 33.33%; }
  50% { transform: scale(calc(2/3), 2); translate: -66.67% -100%; }
  66.67% { transform: scale(2, calc(2/3)); translate: -66.67% 33.33%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 33.33%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 66.67% 33.33%; }
`;

export const boxSixteenAnimation = keyframes`
  0% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
  16.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
  33.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
  50% { transform: scale(2, 2); translate: -100% -100%; }
  66.67% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
  83.33% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
  100% { transform: scale(calc(2/3), calc(2/3)); translate: 33.33% 33.33%; }
`;